export default __webpack_public_path__ + "static/contact-2746528ea19531c9d68a8c6e4f68a768.svg";